var map;

var BlsCreateMapStoreLocation = (function () {
    return {
        init: function () {
            // Clé API Mapbox
            mapboxgl.accessToken = 'pk.eyJ1Ijoia2hpZW1waGFtIiwiYSI6ImNsam01eHhnaTAyNmczZmxzcnQ1MTVqN3gifQ.WVqIQlSk52FSN8W7G5gsnw';
            
            if (!document.getElementById('map')) return;

            map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/mapbox/streets-v12',
                center: [2.41732, 48.9858], 
                zoom: 12,
                pitch: 60,
                bearing: 0
            });

            const stores = document.querySelectorAll('.store-infor__items');
            const storeArray = Array.from(stores).map((element) => {
                return {
                    type: 'Feature',
                    geometry: {
                        type: "Point",
                        coordinates: [Number(element.dataset?.lng), Number(element.dataset?.lat)]
                    },
                    properties: {
                        phone: element.dataset.phone,
                        address: element.dataset.address,
                        name: element.dataset.name,
                        label: element.dataset.label,
                        labelBg: element.dataset.labelBg,
                        labelColor: element.dataset.labelColor,
                        link: element.dataset.link,
                        showLab: element.dataset.showLab === 'true',
                        labBg: element.dataset.labBg,
                        labColor: element.dataset.labColor,
                        showHair: element.dataset.showHair === 'true',
                        hairBg: element.dataset.hairBg,
                        hairColor: element.dataset.hairColor
                    }
                };
            });

            const listStore = {
                type: 'FeatureCollection',
                features: storeArray
            };

            listStore.features.forEach((store, index) => {
                store.properties.id = `store_${index}`;
            });

            map.on('load', () => {
                map.addSource('places', {
                    type: 'geojson',
                    data: listStore
                });

                if (typeof MapboxGeocoder !== 'undefined') {
                    map.addControl(
                        new MapboxGeocoder({
                            accessToken: mapboxgl.accessToken,
                            mapboxgl: mapboxgl
                        }),
                        'top-left'
                    );
                }
                
        map.addControl(
            new mapboxgl.GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true, // Suit l'utilisateur s'il se déplace
                showUserLocation: true,  // Affiche le point bleu sur la carte
                showAccuracyCircle: true // Affiche le cercle de précision
            }),
            'bottom-right' // Position du bouton 
            );
                this.addMarker(listStore);
                this.storeInforAction(listStore);
            });
        },

        addMarker: function (listStore) {
            listStore.features.forEach(store => {
                const marker = document.createElement('div');
                marker.id = `marker-${store.properties.id}`;
                marker.addEventListener('click', e => {
                    this.createPopupMarker(store);
                    this.zoomMarker(store);
                });
                marker.classList.add('marker');
                new mapboxgl.Marker(marker, { offset: [0, -23] })
                    .setLngLat(store.geometry.coordinates)
                    .addTo(map);
            });
        },

      createPopupMarker: function (listStore) {
    const closePopup = document.getElementsByClassName('mapboxgl-popup');
    if (closePopup[0]) closePopup[0].remove();

    const { address, phone, name, label, labelBg, labelColor, link, showLab, labBg, labColor, showHair, hairBg, hairColor } = listStore.properties;
    
    // Formatage du numéro pour le lien tel: (supprime les espaces)
    const phoneClean = phone ? phone.replace(/\s+/g, '') : '';
    
    // Lien pour l'adresse (si pas de lien spécifique, on cherche sur Google Maps)
    const addressLink = link ? link : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

    let labelHtml = '';
    if (label && label.trim() !== '') {
        labelHtml = `<span style="background-color: ${labelBg}; color: ${labelColor}; font-size: 10px; font-weight: 700; text-transform: uppercase; padding: 3px 6px; border-radius: 4px; margin-left: 10px; vertical-align: middle;">${label}</span>`;
    }

    let labHtml = '';
    if (showLab) {
        labHtml = `<span style="background-color: ${labBg}; color: ${labColor}; font-size: 10px; font-weight: 700; text-transform: uppercase; padding: 3px 6px; border-radius: 4px; margin-left: 5px; vertical-align: middle;">LAB</span>`;
    }

    let hairHtml = '';
    if (showHair) {
        hairHtml = `<span style="background-color: ${hairBg}; color: ${hairColor}; font-size: 10px; font-weight: 700; text-transform: uppercase; padding: 3px 6px; border-radius: 4px; margin-left: 5px; vertical-align: middle;">HAIR STUDIO</span>`;
    }

    const popup = new mapboxgl.Popup({ closeOnClick: false })
        .setLngLat(listStore.geometry.coordinates)
        .setHTML(`
            <h3 style="display: flex; align-items: center; flex-wrap: wrap; gap: 5px; margin: 0 0 10px 0;">
                ${name} ${labelHtml} ${labHtml} ${hairHtml}
            </h3>
            <div class="popup-content">
                <a href="${addressLink}" target="_blank" style="text-decoration: none; color: inherit; display: block; margin-bottom: 5px;">
                    <i class="fa fa-map-marker"></i> ${address}
                </a>
                ${phone ? `
                <a href="tel:${phoneClean}" style="text-decoration: none; color: inherit; display: block; font-weight: bold;">
                    <i class="fa fa-phone"></i> ${phone}
                </a>` : ''}
            </div>
        `)
        .addTo(map);
    
    let closeButton = document.querySelector(".bls__location-page .mapboxgl-popup-close-button");
    if(closeButton) {
         closeButton.innerHTML = `<span style="font-size: 16px; font-weight: bold; color: white;">X</span>`;
    }
},

        zoomMarker: function (listStore) {
            map.flyTo({
                center: listStore.geometry.coordinates,
                zoom: 15
            });
        },

        storeInforAction: function (listStore) {
            const listStoresInfor = document.querySelectorAll('.store-infor__name');
            listStoresInfor.forEach(items => {
                items.addEventListener("click", e => {
                    e.preventDefault();
                    const target = e.currentTarget;
                    
                    if (!target.closest('.store-infor__items').classList.contains('store-active')) {
                        document.querySelectorAll('.store-infor__items').forEach(item => {
                            item.classList.remove('store-active');
                        });
                        target.closest('.store-infor__items').classList.add('store-active');
                    } else {
                        target.closest('.store-infor__items').classList.remove('store-active');
                    }
                    
                    const currentFeature = listStore.features.find(feature => target.id === `infor-${feature.properties.id}`);
                    if(currentFeature) {
                        this.createPopupMarker(currentFeature);
                        this.zoomMarker(currentFeature);
                    }
                });
            });
        }
    };
})();

// Déclenchement propre au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
    BlsCreateMapStoreLocation.init();
});